import React from "react";
import styles from "./LandingPage.module.css";

export default function DetectedSetupsSection() {
  return (
    <section id="trade-setups" className={`${styles.section} ${styles.detectedSetupsSection}`}>
      <div className={styles.sectionInner}>
        <div className={styles.textCenter}>
          <div className={styles.sectionLabel}>Detected Setups Engine</div>
          <h2 className={styles.sectionTitle}>Detected Setups Engine</h2>
          <p className={styles.sectionSubtitle}>
            Intraday-only context + rule-based pattern detection with explicit invalidation. Built
            for evaluation — not signals.
          </p>
        </div>

        <div className={styles.detectedSetupsGrid}>
          <div className={styles.detectedSetupsCard}>
            <div className={styles.detectedSetupsPreview}>
              <div className={styles.detectedSetupsPreviewLine} />
              <div className={styles.detectedSetupsPreviewLine} />
              <div className={styles.detectedSetupsPreviewLineWide} />
            </div>
            <h3 className={styles.detectedSetupsCardTitle}>Data + Market Context</h3>
            <p className={styles.detectedSetupsCardDesc}>
              Reads intraday OHLC only (1m / 5m / 15m / 1h) and computes structure + regime before
              scanning setups.
            </p>
            <ul className={styles.detectedSetupsList}>
              <li>Trend structure: HH/HL vs LH/LL</li>
              <li>EMA regime: EMA9 / EMA20 slope + alignment</li>
              <li>ATR / volatility: expansion vs compression</li>
              <li>Session context: Asia / London / NY</li>
              <li>Range state: boxed / rotating price</li>
            </ul>
            <div className={styles.detectedSetupsFooter}>
              Context is derived first — setups are interpreted inside the current regime.
            </div>
          </div>

          <div className={styles.detectedSetupsCard}>
            <div className={styles.detectedSetupsPreview}>
              <div className={styles.detectedSetupsPreviewBadge}>Rules</div>
              <div className={styles.detectedSetupsPreviewBars}>
                <span />
                <span />
                <span />
              </div>
            </div>
            <h3 className={styles.detectedSetupsCardTitle}>Rule-Based Setup Detection</h3>
            <p className={styles.detectedSetupsCardDesc}>
              Scans defined setups with hard rules — no ML, no probabilities, no win-rate
              assumptions.
            </p>
            <ul className={styles.detectedSetupsList}>
              <li>EMA Pullback · Flags/Pennants · VWAP Reclaim</li>
              <li>Range Fade · Failed Breakout (Trap) · ORB</li>
              <li>Momentum Reversal</li>
              <li>Each setup includes: trigger, invalidation/stop, targets</li>
              <li>Expiry rules mark stale setups as EXPIRED</li>
            </ul>
            <div className={styles.detectedSetupsFooter}>
              Everything is explicit + auditable: rules → trigger → invalidation → targets → expiry.
            </div>
          </div>

          <div className={styles.detectedSetupsCard}>
            <div className={styles.detectedSetupsPreview}>
              <div className={styles.detectedSetupsPreviewBadge}>Output</div>
              <div className={styles.detectedSetupsPreviewGrid} />
            </div>
            <h3 className={styles.detectedSetupsCardTitle}>Trader Output + Guardrails</h3>
            <p className={styles.detectedSetupsCardDesc}>
              Outputs what traders need to evaluate — without executing, predicting, or
              recommending trades.
            </p>
            <ul className={styles.detectedSetupsList}>
              <li>Direction (Long/Short), entry trigger, stop, targets</li>
              <li>Why it flagged + checklist items</li>
              <li>Chart annotations: zones, levels, labels</li>
              <li>
                Confidence is rule-based (regime match, clean trigger, R:R ≥ 2, ATR expansion,
                VWAP + volume if relevant)
              </li>
              <li>No execution. No prediction. No signals.</li>
            </ul>
            <div className={styles.detectedSetupsFooter}>
              Pattern + context scanner with explicit invalidation — decision support, not
              automation.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
